import * as index from './index';
index.Schedule.Inject(index.Day, index.Week, index.WorkWeek, index.Month, index.Year, index.Agenda, index.MonthAgenda, index.TimelineViews, index.TimelineMonth, index.TimelineYear, index.Resize, index.DragAndDrop, index.ExcelExport, index.ICalendarExport, index.ICalendarImport, index.Print);
export * from './index';
